export type OrgFinanceSettings = {
  walletEnabled: boolean;
  planAdvanceEnabled: boolean;
};

export const DEFAULT_ORG_FINANCE_SETTINGS: OrgFinanceSettings = {
  walletEnabled: true,
  planAdvanceEnabled: false,
};

/** Missing fields use product defaults (wallet on, plan advance off). */
export const normalizeOrgFinanceSettings = (
  raw?: Partial<OrgFinanceSettings> | null
): OrgFinanceSettings => ({
  walletEnabled: raw?.walletEnabled !== false,
  planAdvanceEnabled: raw?.planAdvanceEnabled === true,
});
